import { render } from "./Upload.vue?vue&type=template&id=18c244fd&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=18c244fd&scoped=true&lang=css"
import "./Upload.vue?vue&type=style&index=1&id=18c244fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c244fd"]])

export default __exports__